<template>
    <!-- v-if="aplCatl===aplCatlCode.ACH" -->
    <div class="w-full flex justify-center sm:contents pb-4">
        <button
            class="btn btn-accent md:bg-white rounded-full sm:mx-2.5 w-[14.5rem] xs:w-[15.625rem] sm:w-auto order-1 sm:order-last"
            @click="continuePolicy()"
        >
            繼續授權下一張保單
        </button>
    </div>
</template>

<script>
import { inject } from 'vue';
import { useRouter } from 'vue-router';
import { submitContinueACH } from '@/apis/aplCatlACH.js';
import { initTransaction } from '@/apis/system';
import routeName from '@/router/constant.js';
import { useStore } from 'vuex';
import codeList from '@/json/codeList.js';
import dialogContent from '@/json/dialogContent';

export default {
    props: {
        regiNo: {
            type: String,
            required: true,
        },
        aplCatl: {
            type: String,
            required: true,
        },
        isLoading: {
            type: Boolean,
            default: false,
        }
    },
    emits: ['update:isLoading'],
    setup(props, { emit }) {
        const store = useStore();
        const router = useRouter();
        const code = codeList.ACH;
        const $vfm = inject('$vfm');

        // 1.於案件受理完成後送出申請繼續授權下一張保單
        const submitContinue = () => {
            return submitContinueACH(props.regiNo).then(() => true
            ).catch(() => false);
        };
        // 2. 交易初始化
        const init = () => {
            return initTransaction(props.aplCatl).then(res => {
                store.dispatch('permissions/setTransactionId', res.data.transactionUniqueId);
                return true;
            }
            ).catch(() => false);
        };

        const modalShow = (params) => {
            $vfm.show({
                component: 'DialogBase',
                params,
                on: {
                    confirm() {
                        $vfm.hide('DialogBase');
                        router.push({ name: routeName.HOME });
                    },
                }
            });
        };
        const continuePolicy = async () => {
            emit('update:isLoading', true);
            // 1.submitContinue(案號)>2.init>3.start>4.continueInfo
            let apiProgressFinish = false;
            if (await submitContinue()) {
                if (await init()) {
                    apiProgressFinish = true;
                }
            }

            if (apiProgressFinish) {
                store.dispatch('services/setChangeItemsResult', { code: `${code}continue`, value: 'getData' });
                router.push({ name: routeName.AUTH_POLICY });
            } else {
                emit('update:isLoading', false);
                modalShow(dialogContent.reApply);
            }
        };
        return { continuePolicy };
    },
};
</script>
